<template>
    <div v-if="event.provider ? event.provider.includes('survey') : false">
        <div class="question-actions">
            <SurveyHistory
                v-if="event.modified_time"
                :id="event.id"
                :event="event"
                :patient="patient"
                :question="question">
            </SurveyHistory>
            <el-button class="edit-button" @click="showEdit = !showEdit">
                <EditSurveyIcon></EditSurveyIcon>
            </el-button>
        </div>
        <el-dialog :append-to-body="true"
            class="send-now-modal edit-question-modal"
            :close-on-click-modal="false"
            :visible.sync="showEdit">
            <span slot="title"> Edit answer </span>
            <div class="question-title">
                {{qNum + "."}} {{ question.title }} <span class="question-content">({{ question.question }})</span>
            </div>
            <div class="date inl">
				{{ qDate }}
			</div>
            <div class="inl">
                <el-select v-model="updateResponse"
                    :multiple="isMultipleSelect"
                    :multiple-limit="maxSelectLimit">
                    <el-option v-for="option in questionOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value">
                    </el-option>
                </el-select>
                <span v-if="updateResponse.length < 1" class="no-answer">
                    Not Answered
                </span>
            </div>
            <div class="footer">
                <div class="remove-response" v-if="showRmvResp">
                    <RemoveResponseIcon></RemoveResponseIcon>
                    <span @click="removeResponse()">Remove Response</span>
                </div>
                <div class="mandatory-quest" v-if="checkIfMandatory()"> 
                    <span>
                        * Mandatory
                    </span>
                </div>
                <el-button type="text" size="small" class="cancel-button" @click="closePopup()">
                    Cancel
                </el-button>
                <LoadingButton
                        type="primary"
                        size="small"
                        class="send-button"
                        :disabled="!enableSave"
                        @click="updateQuestion"
                        :loading="savingEdit">
                    Save
                </LoadingButton>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionEdit from '.'
import Icons from '../analysis/response/icon'
import { v4 as uuidv4 } from 'uuid'

export default {
    name: 'edit-human-map',
    extends: QuestionEdit,

    data() {
        return {
            updateResponse: this.getQuestionResponse(),
            questionOptions: this.getQuestionOptions(),
            enableSave: false,
            showRmvResp: !this.checkIfMandatory() && this.response,
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateSurvey'
        ]),
        closePopup() {
            this.showEdit = false
            this.enableSave = false
            this.updateResponse = this.getQuestionResponse()
            this.showRmvResp = !this.checkIfMandatory() && this.response
        },
        // clickItem(e) {
        //     if(e === this.updateResponse && !this.checkIfMandatory()) this.updateResponse = null
        //     else this.updateResponse = e
        // },
        removeResponse() {
            // this.updateResponse = null
            this.showRmvResp = false
            this.enableSave = this.checkIfMandatory() ? false : true
        },
        onResponseChange() {
            if(this.updateResponse.length > 0) {
                this.enableSave = true
                this.showRmvResp = this.checkIfMandatory() ? false : true;
            } else {
                this.enableSave = this.checkIfMandatory() ? false : true
                this.showRmvResp = false
            }
        },
        updateQuestion() {
            let update = [...this.event.question]
            if(this.updateIndex !== -1)
                update[this.updateIndex] = this.getQuestionUpdate
            else
                update.push(this.getQuestionUpdate)
            console.log('Index - ',this.updateIndex)
            console.log(update)
            //return
            this.savingEdit = true
            this.updateSurvey({
                updateObj: {
                    id: this.event.response,
                    update
                }, 
                surveyId: this.event.id,
                provider: this.event.provider.split(':')[0],
                patient: this.patient.id,
                previousObj: this.event
                })
                .finally(() => {
                    this.savingEdit = false
                    this.showEdit = false
                    this.enableSave = false,
                    this.showRmvResp = !this.checkIfMandatory() && this.response
                })
        },
        getQuestionOptions() {
            switch (this.question.type) {
                case 'human_map':
                default:
                    return []
            }
        },
        getQuestionResponse() {
            if(!this.response)
                return ''
            switch (this.question.type) {
                case 'human_map':
                default:
                    return null
            }
        }
    },

    computed: {
        getQuestionUpdate() {
            let update = {
                id: this.question.id,
                answer: null
            }
            switch (this.question.type) {
                case 'human_map':
            }
            return update
        },
        isMultipleSelect() {
            return ['box_select', 'large_image_select', 'small_image_select', 'select', 'long_text_bubble', 'human_map'].includes(this.question.type)
        },
        maxSelectLimit() {
            return 0
        }
    },

    components: {
        ...Icons
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss'
</style>
